// extracted by mini-css-extract-plugin
module.exports = {"recfooter":"Footer_recfooter__suawp","fbtn":"Footer_fbtn__1oGwD","fHbtn":"Footer_fHbtn__3i2yE","recHfooter":"Footer_recHfooter__3xSyd"};